<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <!-- CONTAINER DE ALERTAS -->
            <alert-container :messages="msgs" />

            <div class="vertical-flow">
                <div class="listing-header mb-3">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('adicionar-forma-pagamento') }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button class="delete-btn" type="button" @click="fecharModal">
                            {{ $t('cancelar') }}
                        </button>
                        <button
                            v-if="(!isUpdate && permissao.create) || (isUpdate && permissao.update)"
                            class="save-btn"
                            type="button"
                            @click="save"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit">
                    <div class="columns is-flex-wrap">
                        <div class="column is-4">
                            <v-input
                                :id="generateId(1)"
                                ref="idErpInput"
                                v-model="formaPagamento.idformapagtoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                uppercase
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!formaPagamento.idformapagtoerp"
                            />
                        </div>
                        <div class="column is-4">
                            <v-input
                                :id="generateId(2)"
                                ref="nomeInput"
                                v-model="formaPagamento.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="descricao"
                                msg="msg-campo-obrigatorio"
                                :invalid="!formaPagamento.descricao"
                                uppercase
                                required
                                tooltipLabel="info-descricao-generica"
                            />
                        </div>
                        <div class="column is-4">
                            <vss-select
                                :id="generateId(3)"
                                ref="situacaoSelect"
                                :searchable="false"
                                :options="situacoes"
                                v-model="situacao"
                                class="no-clear"
                                :mlLabels="true"
                                :disabled="formaPagamento.id == null"
                                title="situacao"
                                tooltipLabel="info-situacao-generica"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssFormaPagamentoClienteService from '@/services/vendas/cliente/abas/AssFormaPagamentoClienteService';
import FormaPagtoService from '@/services/FormaPagtoService';
import FormaPagamentoValidation from '@/services/validations/vendas/FormaPagamentoValidation';
import Message from '@/models/Message';

export default {

    props: {
        idCliente: 0,
        permissaoVincular: false,
    },
    data() {
        return {
            service: new FormaPagtoService(this.$http, this.$router),
            serviceAss: new AssFormaPagamentoClienteService(this.$http, this.$routers),
            validation: new FormaPagamentoValidation(this.msgs),
            isLoading: false,
            msgs: [],
            isSaving: false,
            formaPagamento: {
                id: null,
                descricao: null,
                situacao: null,
            },
            isUpdate: false,
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },
            isVenda: this.$route.meta.contexto == 'vendas',
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'vendas', 'ven-forma-pagamento');
        if (!this.permissao.create) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'forma-pagamento' },
            });
        }
    },
    methods: {
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((value) => {
                    this.formaPagamento = value.content;
                    this.situacao = this.situacoes[this.formaPagamento.situacao];
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },

        save() {
            this.isLoading = true;

            if (this.validation.validate(this.formaPagamento, this.$refs)) {
                let formaTemp = Object.assign({}, this.formaPagamento);
                formaTemp = this.mapTosave(formaTemp);
                formaTemp.situacao = this.situacao.id;

                this.isSaving = true;
                this.service
                    .save(formaTemp)
                    .then((value) => {
                        if (value.message == null) {
                            let msg = 'msg-save-forma-pagamento';
                            if (this.formaPagamento.idformapagto != null) {
                                msg = 'msg-edit-formar-pagamento';
                            }
                            this.msgs.push(new Message('success', msg, true));
                            if (this.permissaoVincular) {
                                this.promptConfirmaVinculo(value.content);
                            } else {
                                this.$emit('fecharModal', null);
                            }
                        } else {
                            if (this.$te(value.message)) {
                                this.msgs.push(new Message('alert', value.message, true));
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }
                    })
                    .catch(() => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'alert',
                                        this.$t(message, { n: formaTemp.idformapagtoerp }),
                                        true,
                                        false
                                    )
                                );
                            } else {
                                this.msgs.push(new Message('alert', message, true));
                            }
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('alert', 'msg-campos-obrigatorios', true));
                this.isLoading = false;
            }
        },
        promptConfirmaVinculo(formapagamento) {
            this.$root.confirm({
                message: this.$t('deseja-realizar-vinculo'),
                onConfirm: (_) => {
                    this.realizarVinculo(formapagamento);
                },
                onCancel: (_) => {
                    this.fecharModal();
                },
            });
        },
        realizarVinculo(formapagamento) {
            let assTemp = {
                idformapagto: formapagamento.idformapagto,
                idcliente: this.idCliente,
            };

            this.saveFP(assTemp)
                .then((value) => {
                    if (value.message == null) {
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                        this.$emit('fecharModal', null);
                    } else {
                        if (this.$t(value.message)) {
                            this.msgs.push(new Message('alert', value.message, true));
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                    }
                })
                .catch((e) => {
                    this.msgs.push(new Message('alert', 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        saveFP(assTemp) {
            if (this.isVenda) return this.serviceAss.saveAssVendas(assTemp);
            else return this.serviceAss.saveAssAgro(assTemp);
        },
        fecharModal() {
            this.$emit('fecharModal', null);
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
